angular
  .module("checkListPostVendita.components", [])
  .component("checkListPostVendita", {
    templateUrl:
      "ng/components/checkListPostVendita/checkListPostVendita.view.html",
    bindings: {
      listOfDocument: "=",
      model: "=",
      linkDownload: "@",
      restFinish: "<",
      validateUpload: "&",
      numContratto: "=",
      numModulo: "=",
      allegati: "&",
      postVendita: "<",
      digitalSign: "<",
      messageUpload: "<",
      messageDownload: '<'
    },
    controllerAs: "checkListPVCtrl",
    controller: CheckListPostVendita,
  });

function CheckListPostVendita(
  FileUploader,
  $simulationService,
  $configService,
  $rootScope,
  $timeout,
  $financialApiService,
  $portalService,
  $download
) {
  var self = this;
  self.listOfInfo = [];
  jQuery(document).ready(function ($) {
    var alterClass = function () {
      var ww = jQuery(window).width();
      if (ww < 900) {
        $('.resize-table').removeClass('ui inverted');
      } else if (ww >= 900) {
        $('.resize-table').addClass('ui inverted');
      };
    };
    jQuery(window).resize(function () {
      alterClass();
    });
    //Fire it when the page first loads:
    $timeout(function () {
      alterClass();
    }, 200)
  });

  self.$onInit = function () {
    self.uploadStart = [];
    self.uploadFinished = [];
    self.downloadStart = [];
    self.downloadFinished = [];
    self.visualProgBarDoc = [];
    self.enableLoaderDelete = [];
    self.loadingStatus = {
      uploading: false,
    };
    self.checkStatusOfFile();
  };

  self.$onChanges = function (changed) {
    if (
      changed.restFinish &&
      typeof changed.restFinish.currentValue != "undefined"
    ) {
      self.waitFromRest = changed.restFinish.currentValue;

      if (!changed.restFinish.currentValue) {
        checkInformative();
        self.checkStatusOfFile();
      }
    }
    // if (self.restFinish) {
    //   self.waitFromRest = false;
    // }
  };

  self.check = function (el) {
    el.selected = !el.selected;
  };

  var checkInformative = function () {
    self.informativeIsPresent =
      self.listOfDocument &&
      self.listOfDocument.some(function (element) {
        return element.informative == true;
      });

    self.informativeIsNotPresent =
      self.listOfDocument &&
      self.listOfDocument.some(function (element) {
        return element.informative == false;
      });
  };

  self.uploader = new FileUploader({
    url: "",
    headers: {
      "Access-Control-Allow-Origin": "*",
      Token: "Bearer " + ($configService.getAppConfig().token || "no-token"),
      "App-Name": $rootScope.portalName,
    },
  });

  self.uploadDataFunc = function (item, index) {
    var document =
      arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (item) {
      self.uploadData = item;
    }
    self.uploadDocumenti = document;
    self.currentCodeTypeNameIndex = index;
    self.isSplit = arguments[4] && arguments[4];
    self.singleFile = self.listOfDocument[index];
  };

  self.finalUpload = function () {
    console.log("calling finalUpload");
    self.folderPath = "" + new Date().getTime();
    var url =
      $configService.getAppConfig().url +
      "/uni/upload/service-infos/" +
      "/FINANCIAL-" +
      self.singleFile.codiceDocNSIL;

    self.disabledForUploadingInProgress = true;
    for (var int = 0; int < self.uploader.queue.length; int++) {
      self.uploader.queue[int].url = url;
    }
    self.loadingStatus.uploading = true;
    var filesUpload = document.querySelector(
      "#uploadInput_document_" + self.currentCodeTypeNameIndex
    ).files;
    filesUpload = Object.keys(filesUpload).map(function (key) {
      return filesUpload[key];
    });
    var formData = new FormData();

    jQuery("#uploadInput_document_" + self.currentCodeTypeNameIndex).val("");

    filesUpload.forEach(function (file) {
      appendToForm(formData, "file", file);
      appendToForm(formData, "type", "RICHIESTE_CLIENTI");
      appendToForm(formData, "filename", file.name);
      appendToForm(formData, "idPratica", self.model.id);
      appendToForm(formData, "cdDoc", self.singleFile.cdDocNsil);
      appendToForm(formData, "numeroContratto", self.numContratto);
      appendToForm(formData, "modulo", self.numModulo);
      appendToForm(formData, "ndgCliente", $configService.getUser().ndg);
      appendToForm(formData, "external", self.singleFile.external);
      appendToForm(formData, "digitale", self.digitalSign);
      self.uploadStart[self.currentCodeTypeNameIndex] = true;
      self.uploadFinished[self.currentCodeTypeNameIndex] = false;
      $financialApiService
        .uploadDocOnPv(formData)
        .then(function (response) {
          if (response.success) {
            $timeout(function () {
              self.uploadStart[self.currentCodeTypeNameIndex] = false;
              self.uploadFinished[self.currentCodeTypeNameIndex] = true;
              var tmp = {
                filename: file.name,
                id: response.id,
                cdDoc: self.singleFile.cdDocNsil,
                status: "1",
                selected: false,
                downloadKey: response.downloadKey
              };

              self.visualProgBarDoc[self.currentCodeTypeNameIndex] = false;
              self.listOfDocument[
                self.currentCodeTypeNameIndex
              ].uploadedFiles.push(tmp);
              self.listOfDocument[
                self.currentCodeTypeNameIndex
              ].uploadedFiles.forEach(x => {
                if (x.status == 2) {
                  x.status = 3;
                }
              })
              self.listOfDocument[self.currentCodeTypeNameIndex].status = "1";
              self.disabledForUploadingInProgress = false;

              var tmpPostVendita = {
                filename: file.name,
                estensione: file.type,
                id: response.id,
                downloadKey: response.downloadKey
              };

              self.allegati({
                allegati: tmpPostVendita,
              });

              self.checkStatusOfFile();
            }, 1);
          } else {
            self.visualProgBarDoc[self.currentCodeTypeNameIndex] = false;
            self.disabledForUploadingInProgress = false;
            self.uploadStart[self.currentCodeTypeNameIndex] = false;
          }

          $timeout(function () {

            self.uploadFinished[self.currentCodeTypeNameIndex] = true;
          }, 500)
        })
        .catch(function (error) {
          self.disabledForUploadingInProgress = false;
          self.visualProgBarDoc[self.currentCodeTypeNameIndex] = false;
          self.uploadStart[self.currentCodeTypeNameIndex] = false;
          $timeout(function () {
            self.uploadFinished[self.currentCodeTypeNameIndex] = true;
          }, 500)
        });
    });
  };

  self.generateDownloadLink = function (file) {
    var url = ""
    if (file.zipMode) {
      url =
        "/uni/downloadGenericPv/service-infos/FINANCIAL/" +
        encodeURIComponent(file.cdDoc) +
        "/zip/" +
        encodeURIComponent(self.model.idWfInstance) +
        "/"

    } else {
      url =
        "/uni/downloadGenericPv/service-infos/FINANCIAL/" +
        encodeURIComponent(file.cdDoc) +
        "/" +
        encodeURIComponent(file.id) +
        "/" +
        encodeURIComponent(self.model.idWfInstance) +
        "/"
    }

    $download.getGenericDownload(url)
      .then(function (response) {
        console.log(response);
      })
  };

  self.uploader.onWhenAddingFileFailed = function (item, filter, options) {
    console.info("onWhenAddingFileFailed", item, filter, options);
  };

  self.uploader.onAfterAddingFile = function (fileItem) {
    console.log("fileItem", fileItem);
    self.disabledForUploadingInProgress = true;
    self.progresso = 0;
    if (fileItem.file.size > 26214400) {
      $rootScope.$broadcast("addAlert", {
        text: "MAXIMUM_FILE_SIZE_EXCEEDED",
      });
      fileItem.remove();
      jQuery("#uploadInput_document_" + self.currentCodeTypeNameIndex).val("");
    }
    var fileName = fileItem.file.name;
    if (
      fileName.toLowerCase().indexOf(".png") > -1 ||
      fileName.toLowerCase().indexOf(".jpg") > -1 ||
      fileName.toLowerCase().indexOf(".jpeg") > -1 ||
      fileName.toLowerCase().indexOf(".tiff") > -1 ||
      fileName.toLowerCase().indexOf(".pdf") > -1 ||
      fileName.toLowerCase().indexOf(".zip") > -1 ||
      fileName.toLowerCase().indexOf(".p7m") > -1
    ) {
      self.uploader.queue[0].progress = 100;

      self.visualProgBarDoc[self.currentCodeTypeNameIndex] = true;

      $timeout(function () {
        self.progresso = 100;
      }, 500);
    } else {
      fileItem.remove();
      jQuery("#uploadInput_document_" + self.currentCodeTypeNameIndex).val("");
      $rootScope.$broadcast("addAlert", {
        text: "FORMAT_NOT_SUPPORTED",
      });
      self.disabledForUploadingInProgress = false;
      self.uploadInProgess({
        uploadInProgess: false,
      });
    }
  };

  self.uploader.onAfterAddingAll = function (addedFileItems) {
    console.info("onAfterAddingAll", addedFileItems);
    self.finalUpload(self.uploadData);
  };

  self.uploader.onBeforeUploadItem = function (item) {
    item.file.name = window.encodeURIComponent(item.file.name);
    item.headers["Token"] = "Bearer " + $configService.getAppConfig().token;
    self.disabledForUploadingInProgress = true;
  };

  self.uploader.onProgressItem = function (fileItem, progress) {
    self.uploadCompleted = false;
  };

  self.uploader.onProgressAll = function (progress) { };

  self.uploader.onSuccessItem = function (fileItem, response, status, headers) {
    self.loadingStatus.uploading = false;
  };

  self.uploader.onErrorItem = function (fileItem, response, status, headers) {
    console.info("onErrorItem", fileItem, response, status, headers);
    self.loadingStatus.uploading = false;
    jQuery("#uploadInput_document_" + self.currentCodeTypeNameIndex).val("");

    $rootScope.$broadcast("addAlert", {
      text: "ERROR_UPLOADING_FILE",
    });

    self.disabledForUploadingInProgress = false;

    $timeout(function () {
      self.visualProgBarDoc[self.currentCodeTypeNameIndex] = false;
    }, 1);

    fileItem.remove();
    jQuery("#uploadInput_document_" + self.currentCodeTypeNameIndex).val("");
  };

  self.uploader.onCancelItem = function (fileItem, response, status, headers) {
    console.log(status);
  };

  self.uploader.onCompleteItem = function (
    fileItem,
    response,
    status,
    headers
  ) {
    console.info("onCompleteItem", fileItem, response, status, headers);
    if (
      response &&
      response.uploadFileServicePojo &&
      response.uploadFileServicePojo.success
    ) {
      self.uploadOk = true;
      console.log(fileItem);

      var document = {
        fileStatus: null,
        isSelected: false,
        nameFile: response.uploadFileServicePojo.fileName,
        uuid: "",
        errorMessage: "",
        documentClass: "",
      };

      self.listOfDocument = response.metadataUniUpload.uploadedfile.sort(
        function (a, b) {
          if (a.codiceDocNSIL > b.codiceDocNSIL) {
            return 1;
          } else {
            return -1;
          }
        }
      );
      self.checkStatusOfFile();
    }
    self.uploader.queue = [];

    $timeout(function () {
      self.visualProgBarDoc[self.currentCodeTypeNameIndex] = false;

      self.disabledForUploadingInProgress = false;
    }, 1);
    jQuery("#uploadInput_document_" + self.currentCodeTypeNameIndex).val("");
  };

  self.uploader.onCompleteAll = function () {
    console.info("onCompleteAll");
    self.uploadCompleted = true;
  };

  self.uploader.onSuccessItem = function (fileItem, response, status, headers) {
    self.uploading = false;
  };

  self.deletePrivacyDocument = function (index, singleFile) {
    self.progresso = 100;

    self.visualProgBarDoc[index] = true;

    $timeout(function () {
      self.progresso = 0;
    }, 200);

    self.documentsToBeDeleted = self.listOfDocument[index].uploadedFiles.filter(
      function (elem) {
        return elem.id == singleFile.id;
      }
    );

    var documentRow =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    self.documentsToBeDeleted.forEach(function (element) {
      if (
        $portalService.isAru() &&
        self.model.leasingData.preventivo.completatoArc
      ) {
        self.model.leasingData.preventivo.documents.refused =
          self.model.leasingData.preventivo.documents.refused.filter(function (
            elem
          ) {
            return elem != element.id;
          });
      }

      $simulationService
        .deleteChecklistFilePv(element.id)
        .then(function (response) {
          console.log(response);
          $timeout(function () {
            self.visualProgBarDoc[index] = false;
            self.listOfDocument[index].uploadedFiles = self.listOfDocument[
              index
            ].uploadedFiles.filter(function (e) {
              return elem.id != singleFile.id;
            });
            if (self.listOfDocument[index].uploadedFiles.length == 0) {
              self.listOfDocument[index].status = "0";
            }
            self.listOfDocument[index].uploadedFiles.forEach(x => {
              if (x.status == 3) {
                x.status = 2;
              }
            })
            self.uploadOk = false;
            self.checkStatusOfFile();
          }, 1);
        })
        .catch(function (error) {
          $rootScope.$broadcast("addAlert", {
            text: "ERROR_TEC",
          });
          self.checkStatusOfFile();
        });
    });
  };

  self.checkStatusOfFile = function () {
    self.listOfDocument &&
      self.listOfDocument.forEach(function (e, index) {
        var status = parseInt(e.status);

        var infoFiles = {
          icon: "",
          visualChek: true,
          visualTrash: true,
          status: 0,
        };
        if (!status) {
          infoFiles.icon = "icon-error text-red";
          infoFiles.visualTrash = true;
          infoFiles.status = 0;
          self.listOfInfo[index] = infoFiles;
          return;
        }

        switch (status) {
          case 1:
            infoFiles.icon = " icon-question-circle1 gray";
            infoFiles.visualTrash = true;
            infoFiles.status = 1;
            self.listOfInfo[index] = infoFiles;
            break;
          case 2:
            infoFiles.icon = "icon-exclamation-circle1 text-red";
            infoFiles.visualTrash = false;
            infoFiles.status = 2;
            self.listOfInfo[index] = infoFiles;
            break;
          case 3:
            infoFiles.icon = "icon-error text-red";
            infoFiles.visualTrash = false;
            infoFiles.status = 3;
            self.listOfInfo[index] = infoFiles;
            break;
          case 4:
            infoFiles.icon = "icon-flag1 green";
            infoFiles.visualTrash = false;
            infoFiles.status = 4;
            self.listOfInfo[index] = infoFiles;
            break;
          default:
            infoFiles.icon = "icon-error text-red";
            infoFiles.visualTrash = false;
            infoFiles.status = 0;
            self.listOfInfo[index] = infoFiles;
            break;
        }
      });

    var allDocMandatory = self.listOfDocument &&
      self.listOfDocument.filter(function (element) {
        return element.mandatory == true && element.hideUpload == false;
      });

    if (allDocMandatory && allDocMandatory.length) {
      var allDocUploaded = allDocMandatory.every(function (el) {

        return el.uploadedFiles[0] && el.uploadedFiles[0].showDownload ? el.uploadedFiles.length > 1 : el.uploadedFiles.length > 0;
      });

      //se il documento è stato rifiutato, deve essere caricato un nuovo documento
      var documentToCorrect = false;

      self.listOfDocument
        .filter(function (el) {
          return el.uploadedFiles.length > 0;
        })
        .forEach(function (element) {
          documentToCorrect =
            documentToCorrect ||
            element.uploadedFiles.every(function (el) {
              return el.note != null;
            });
        });

      if (allDocUploaded && !documentToCorrect) {
        self.validateUpload({
          validity: true,
        });
      } else {
        self.validateUpload({
          validity: false,
        });
      }
    } else {
      self.validateUpload({
        validity: true,
      });
    }
  };

  self.genericTrashCheck = function (index) {
    return (
      self.listOfDocument[index] &&
      self.listOfDocument[index].uploadedFiles &&
      self.listOfDocument[index].uploadedFiles.some(function (element) {
        return element.selected == true;
      })
    );
  };

  self.deletePrivacyDocument = function (index, singleFile, internalIndex) {
    self.progresso = 100;

    self.visualProgBarDoc[index] = true;
    self.enableLoaderDelete[internalIndex] = true;
    $timeout(function () {
      self.progresso = 0;
    }, 200);

    self.documentsToBeDeleted = self.listOfDocument[index].uploadedFiles.filter(
      function (elem) {
        return elem.id == singleFile.id;
      }
    );

    var documentRow =
      arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    self.documentsToBeDeleted.forEach(function (element) {
      if (
        $portalService.isAru() &&
        !self.postVendita &&
        self.model.leasingData &&
        self.model.leasingData.preventivo &&
        self.model.leasingData.preventivo.completatoArc
      ) {
        self.model.leasingData.preventivo.documents.refused =
          self.model.leasingData.preventivo.documents.refused.filter(function (
            elem
          ) {
            return elem != element.id;
          });
      }

      var checklistType = self.postVendita ? "PV" : null;
      $simulationService
        .deleteChecklistFilePv(element.id, checklistType)
        .then(function (response) {
          console.log(response);
          $timeout(function () {
            self.visualProgBarDoc[index] = false;
            self.listOfDocument[index].uploadedFiles = self.listOfDocument[
              index
            ].uploadedFiles.filter(function (e) {
              return e.id != singleFile.id;
            });
            if (self.listOfDocument[index].uploadedFiles.length == 0) {
              self.listOfDocument[index].status = "0";
            }
            self.listOfDocument[index].uploadedFiles.forEach(x => {
              if (x.status == 3) {
                x.status = 2;
              }
            })
            self.uploadOk = false;
            self.checkStatusOfFile();
            self.enableLoaderDelete[internalIndex] = false;
          }, 1);
        })
        .catch(function (error) {
          $rootScope.$broadcast("addAlert", {
            text: "ERROR_TEC",
          });
          self.enableLoaderDelete[internalIndex] = false;
          self.checkStatusOfFile();
        });
    });
  };

  self.downloadedFiles = function (file) {
    var url = "/uni/downloadDocPv/service-infos/";
    var input = {
      downloadKey: file.downloadKey
    }
    $download.getGenericDownload(url, input)
      .then(function (response) {
        console.log(response)
      })
  };
}
